import React from 'react'
import './home-css/hello.css'
function Hello() {
  return (
    <div className='fine'>hello</div>
  )
}

export default Hello